import { Button } from "@allaria-tech/matter/Button";
import { Typography } from "@allaria-tech/matter/Typography";

import FalFundDonut from "./FalFundDonut";
import { falFundSelectionCopy as copy } from "../../i18n/falFundSelection";
import { FalFund, getAssetColor } from "../../utils/falFunds";

import styles from "./FalFundSelectionPage.module.scss";

interface Props {
  fund: FalFund;
  ratesDate: string;
  onChoose: () => void;
}

const FalFundCard = ({ fund, ratesDate, onChoose }: Props) => {
  const {
    card,
    cardHeader,
    chart,
    legend,
    legendItem,
    legendDot,
    metrics,
    metric,
    metricValue,
    chooseButton,
  } = styles;

  return (
    <section className={card}>
      <div className={cardHeader}>
        <Typography type="HEADING" size="S" tag="h2">
          {fund.nombre}
        </Typography>
        <Typography type="DETAIL" size="M" tag="p">
          {fund.descripcion}
        </Typography>
      </div>

      <div className={chart}>
        <FalFundDonut allocation={fund.composicion} />
        <ul className={legend}>
          {fund.composicion.map(({ activo, pct }, index) => (
            <li key={activo} className={legendItem}>
              <span
                className={legendDot}
                style={{ backgroundColor: getAssetColor(activo, index) }}
              />
              <Typography type="LABEL" size="M" weight="STRONG">
                {`${pct}%`}
              </Typography>
              <Typography
                type="DETAIL"
                size="M"
                color="var(--typography-body-color-soft)"
              >
                {activo}
              </Typography>
            </li>
          ))}
        </ul>
      </div>

      <div className={metrics}>
        <div className={metric}>
          <Typography type="DETAIL" size="M">
            {copy.expectedYield}
          </Typography>
          <Typography type="METRIC" size="L" tag="p" className={metricValue}>
            {fund.tna}
          </Typography>
          <Typography type="DETAIL" size="M">
            {copy.ratesAsOf(ratesDate.slice(0, 5))}
          </Typography>
        </div>
        <div className={metric}>
          <Typography type="DETAIL" size="M">
            {copy.duration}
          </Typography>
          <Typography type="METRIC" size="L" tag="p" className={metricValue}>
            {fund.duration}
          </Typography>
          <Typography type="DETAIL" size="M">
            {copy.years}
          </Typography>
        </div>
      </div>

      <Button
        className={chooseButton}
        text={copy.choose}
        type="button"
        testId={`fal-fund-${fund.id}`}
        onClick={onChoose}
      />
    </section>
  );
};

export default FalFundCard;
